import React from "react";
import { ProWidget1, ProWidget2, ProWidget3 } from "./AllProjectDashCharts";

const Widgets = () => {
  return (
    <React.Fragment>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-1 2xl:grid-cols-3">
        <div className="flex items-center justify-between gap-6 p-5 bg-white border rounded dark:bg-darklight dark:border-darkborder border-black/10">
          <div>
            <p className="text-base dark:text-white/80">Upcoming Projects</p>
            <h4 className="flex items-center gap-4 mt-3 text-2xl font-semibold text-black dark:text-white">
              198
              <span className="p-1 text-sm leading-none rounded-md bg-success/20 text-success">
                14.98%
              </span>
            </h4>
            <p className="mt-3 mb-0 text-muted">Current Month</p>
          </div>
          <div>
            <div id="chart" dir="ltr">
              <ProWidget1 />
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between gap-6 p-5 bg-white border rounded dark:bg-darklight dark:border-darkborder border-black/10">
          <div>
            <p className="text-base dark:text-white/80">Total Projects</p>
            <h4 className="flex items-center gap-4 mt-3 text-2xl font-semibold text-black dark:text-white">
              4581
              <span className="p-1 text-sm leading-none rounded-md bg-danger/20 text-danger">
                24%
              </span>
            </h4>
            <p className="mt-3 mb-0 text-muted">Current Month</p>
          </div>
          <div>
            <div id="chart2" dir="ltr">
              <ProWidget2/>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between gap-6 p-5 bg-white border rounded dark:bg-darklight dark:border-darkborder border-black/10">
          <div>
            <p className="text-base dark:text-white/80">Total Referral</p>
            <h4 className="flex items-center gap-4 mt-3 text-2xl font-semibold text-black dark:text-white">
              2140
              <span className="p-1 text-sm leading-none rounded-md bg-danger/20 text-danger">
                10%
              </span>
            </h4>
            <p className="mt-3 mb-0 text-muted">Current Month</p>
          </div>
          <div>
            <div id="chart4" dir="ltr">
              <ProWidget3 />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Widgets;
